import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { DangerContainedButton } from './styles';

interface Props {
  open: boolean;
  title: string;
  body: React.ReactNode;
  // The confirm button. `variant: 'danger'` swaps the contained colour to
  // the shared destructive style (matches the inline Delete buttons in the
  // parent card). `variant: 'primary'` keeps the standard primary blue.
  confirmLabel: string;
  confirmPendingLabel: string;
  pending: boolean;
  variant?: 'primary' | 'danger';
  onClose: () => void;
  onConfirm: () => void;
}

// Generic confirm prompt. Used for the three destructive / one-shot flows
// (Delete release, Restore template backup, Delete template backup) —
// they're all "title + paragraph + Cancel/confirm" with only labels and
// colour varying.
export const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  body,
  confirmLabel,
  confirmPendingLabel,
  pending,
  variant = 'primary',
  onClose,
  onConfirm,
}) => {
  const ConfirmButton =
    variant === 'danger' ? DangerContainedButton : Button;
  return (
    <Dialog
      open={open}
      onClose={() => {
        if (!pending) onClose();
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{body}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={pending}>
          Cancel
        </Button>
        <ConfirmButton
          onClick={onConfirm}
          variant="contained"
          color={variant === 'primary' ? 'primary' : undefined}
          disabled={pending}
        >
          {pending ? confirmPendingLabel : confirmLabel}
        </ConfirmButton>
      </DialogActions>
    </Dialog>
  );
};
